import * as React from 'react';
import { isAttachmentPath } from 'Utility/location';
import { mapGroupsToCapabilities } from '../../config/groupMapping';

const CapabilityContext = React.createContext<ICapabilityContextProps | null>(null);

const CapabilityProvider = CapabilityContext.Provider;
const CapabilityConsumer = CapabilityContext.Consumer;

const CapabilityHandler = ({ children }: { children: React.JSX.Element }): React.JSX.Element => {
  const [value, setValue] = React.useState<ICapabilityContextProps | null>(null);

  React.useEffect(() => {
    if (isAttachmentPath()) {
      setValue({ capabilityGroups: {} });
      return;
    }
    mapGroupsToCapabilities()
      .then(p => setValue({ capabilityGroups: p }))
      .catch(() => {
        return;
      });
  }, []);

  return <CapabilityProvider value={value}>{children}</CapabilityProvider>;
};

export const withCapabilities = <P extends object>(Component: React.ComponentType<P>): React.FC<P> => {
  return (props: P): React.JSX.Element => (
    <CapabilityConsumer>
      {(context: ICapabilityContextProps | null): React.JSX.Element => (
        <Component capabilityGroups={context?.capabilityGroups ?? undefined} {...props} />
      )}
    </CapabilityConsumer>
  );
};

export interface ICapabilityContextProps {
  capabilityGroups?: IGroupACLMapping;
}

export default CapabilityHandler;
